import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, compose, withHandlers, withStateHandlers } from 'recompose'
import { showFindLowerPriceModal } from 'components/FindLowerPriceModal/actions'
import { showStoreLocatorModal } from 'actions/storeLocator'
import { googleAnalyticProductClicks } from 'actions/googleAnalytic'
import { getCurrentStore } from 'selectors'
import { addToProductCompare } from 'components/OneColumnSearchResultPage/actions'
import {
  isCompareTrayFull,
  getIsAllCompatible,
  getOeItemIdsList,
  getItemsWithInventory
} from 'components/OneColumnSearchResultPage/selectors'
import { getReviewsLink } from 'components/OneColumnSearchResultPage/helpers'
import { getGTMRecommendedProductData, getProductAvailabilityFromList } from '../../helpers'
import { RECOMMENDED_PRODUCT, SEARCH_RESULT_SOURCE } from 'constant'
import { PRICE_SET_MAX, PRICE_SET_MIN, PROMOTIONS_MIN_ITEMS } from 'components/OneColumnSearchResultPage/constants'
import RecommendedProduct from './RecommendedProduct'
import InlineRecommendedProductView from './InlineRecommendedProduct'
import { getPromoAndSpecsMenu, productFlagIdCheck } from '../../../helpers'
import { getElectricVehicleSpecifications } from 'components/common/ProductFlag/helpers'
import { INVENTORY_STATUS_LOADED } from 'components/common/UpdatingBlock/constants.js'
import { getUserData } from 'components/Appointment/selectors'
import { checkIsCompatible } from 'helpers/compatibility'

const mapStateToProps = (state, { skuId, bvId, compatibilityState }) => {
  const { isPilotStore } = getUserData(state)
  const itemsWithInventory = getItemsWithInventory(state)
  const availability = itemsWithInventory.length ? getProductAvailabilityFromList({ itemsWithInventory, bvId }) : {}

  return {
    myStore: getCurrentStore(state),
    isAllCompatible: getIsAllCompatible(state),
    isCompareTrayFull: isCompareTrayFull(state),
    isOeItem: productFlagIdCheck(getOeItemIdsList(state), skuId),
    isPilotStore,
    inventoryStatuses: state.updatingBlocks[INVENTORY_STATUS_LOADED],
    availability,
    isCompatible: checkIsCompatible(compatibilityState)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {
    brandLogoUrl,
    imagePath: imageUrl,
    productDisplayName: tireLineName,
    skuId,
    tireDetailUrl,
    staggeredSku
  } = ownProps

  return {
    googleAnalyticProductClicks: bindActionCreators(googleAnalyticProductClicks, dispatch),
    showStoreLocatorModal: bindActionCreators(showStoreLocatorModal, dispatch),
    handleFindLowerPriceClick() {
      dispatch(showFindLowerPriceModal(skuId))
    },
    handleCompareTrayAdd() {
      dispatch(addToProductCompare({
        brandLogoUrl,
        imageUrl,
        tireLineName,
        skuId: staggeredSku || skuId,
        tireDetailUrl,
        isStaggered: Boolean(staggeredSku)
      }))
    }
  }
}

const withTileProps = withProps(({
  skuId,
  index,
  skuDisplayName,
  tireDetailUrl,
  skuPromotions,
  bestValueToolTipMessage,
  compareTrayItems,
  isCompareTrayFull,
  staggeredSku,
  specifications
}) => {
  const productSkuId = staggeredSku || skuId
  const compareDisabled = isCompareTrayFull ||
    compareTrayItems.some(({ skuId }) => productSkuId === skuId)

  const expanderMenu = getPromoAndSpecsMenu(skuPromotions)
  const electricVehicleSpecifications = getElectricVehicleSpecifications(specifications)

  return {
    reviewsLink: getReviewsLink(tireDetailUrl),
    sizeFront: skuDisplayName,
    quantityInputId: `${RECOMMENDED_PRODUCT}-${productSkuId}-${index}`,
    defaultQuantityValue: PRICE_SET_MAX,
    promotions: skuPromotions || [],
    tooltip: bestValueToolTipMessage,
    compareDisabled,
    expanderMenu,
    isEvItem: Boolean(electricVehicleSpecifications.length),
    itemEVType: electricVehicleSpecifications.length ? electricVehicleSpecifications[0].specValue : null
  }
})

const withProductClickHandler = withHandlers({
  handleProductClick: ({
    index: position,
    title: label,
    price,
    skuId,
    brandName,
    skuDisplayName,
    productDisplayName,
    googleAnalyticProductClicks
  }) => () => {
    googleAnalyticProductClicks({
      data: getGTMRecommendedProductData({
        skuId,
        price,
        label,
        position,
        brandName,
        skuDisplayName,
        productDisplayName
      }),
      ...SEARCH_RESULT_SOURCE
    })
  }
})

// TODO refactor this using more reliable way
const withRecommendedProductState = withStateHandlers(
  ({ staggeredSku, promotions }) => ({
    countFront: staggeredSku ? PRICE_SET_MIN : PRICE_SET_MAX,
    countRear: staggeredSku ? PRICE_SET_MIN : PRICE_SET_MAX,
    promotionsPreviewItems: promotions.slice(0, PROMOTIONS_MIN_ITEMS),
    promotionsRestItems: promotions.slice(PROMOTIONS_MIN_ITEMS)
  }),
  {
    handleFrontQuantityChange: () => value => ({
      countFront: value
    }),
    handleRearQuantityChange: () => value => ({
      countRear: value
    })
  }
)

const withDisableAddToQuote = withProps(({
  countFront,
  isCompatible
}) => ({
  disableAddToQuote: !countFront || !isCompatible
}))

const recommendedCompose = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTileProps,
  withProductClickHandler,
  withRecommendedProductState,
  withDisableAddToQuote
)

export default recommendedCompose(RecommendedProduct)

const InlineRecommendedProduct = recommendedCompose(InlineRecommendedProductView)

export { InlineRecommendedProduct }
